import I18n from 'I18n';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Alert = styled(UIAlert).withConfig({
  displayName: "BaseRichTextEditorError__Alert",
  componentId: "sc-1ejzht1-0"
})(["width:100%;"]);
const ErrorMessageContainer = styled.div.withConfig({
  displayName: "BaseRichTextEditorError__ErrorMessageContainer",
  componentId: "sc-1ejzht1-1"
})(["display:flex;flex-grow:1;align-self:stretch;padding:20px;align-items:start;"]);
export default function BaseRichTextEditorError({
  reset
}) {
  return /*#__PURE__*/_jsx(ErrorMessageContainer, {
    children: /*#__PURE__*/_jsx(Alert, {
      titleText: I18n.text('composer-ui.editor-utilities.error.title'),
      type: "danger",
      children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.editor-utilities.error.description"
        }), reset && /*#__PURE__*/_jsx(UIButton, {
          size: "extra-small",
          use: "tertiary",
          onClick: reset,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "composer-ui.editor-utilities.error.reset-button"
          })
        })]
      })
    })
  });
}
BaseRichTextEditorError.displayName = 'BaseRichTextEditorError';